var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWarehousesNotactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-warehouses-notactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484c52",
    d: "M28.569 9.246c0-0.114-0.026-0.222-0.066-0.324-0.012-0.033-0.030-0.062-0.047-0.094-0.033-0.066-0.075-0.128-0.124-0.183-0.025-0.030-0.049-0.055-0.076-0.080-0.057-0.050-0.121-0.091-0.188-0.128-0.030-0.015-0.057-0.034-0.087-0.047-0.011-0.004-0.020-0.012-0.030-0.016l-11.648-4.046c-0.197-0.069-0.41-0.068-0.608 0l-11.626 4.073c-0.37 0.13-0.618 0.479-0.618 0.871 0 0.018 0.007 0.033 0.009 0.052-0.007 0.044-0.027 0.084-0.027 0.129v13.271c0 0.391 0.249 0.742 0.618 0.871l11.643 4.074c0.098 0.034 0.202 0.052 0.305 0.052 0.102 0 0.206-0.017 0.305-0.052l11.647-4.071c0.372-0.129 0.619-0.48 0.619-0.871v-13.481c0 0 0 0 0-0.001 0 0 0 0 0 0zM15.999 6.18l8.849 3.073-8.852 3.115-8.832-3.095 8.834-3.093zM5.278 10.569l9.797 3.433v11.495l-9.797-3.426v-11.502zM16.921 25.498v-11.498l9.802-3.45v11.521l-9.802 3.426z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarehousesNotactive);
export default __webpack_public_path__ + "static/media/icon-warehouses-notactive.b12ca010.svg";
export { ForwardRef as ReactComponent };